export const settleParamsList = [
  {
    type: 1, //唯一标识符，万店上选
    api: '/wdsx-shop/payment/payByWeiXinJSAPI',
    successUrl: 'http://wdsxapi.ovopark.com/order-success',
    failUrl: 'http://wdsxapi.ovopark.com/order',
    title:'万店上选'
  },
  {
    type: 2, //万店云集
    api: '/live/pay/orderWeChatPay',
    jssdkApi: '/live/common/getWeixinConfig',
    successUrl: 'http://wdsxapi.ovopark.com/live/index.html#/payResult?from=pay',
    failUrl: 'http://wdsxapi.ovopark.com/live/index.html#/orderPay?from=pay',
    title:'万店云集'
  }
]